<template>
    <div>
      <div class="row justify-content-between align-items-center">
        <div class="col-md-3 customHeading">
          <h3>{{moduleName}}</h3>
        </div>
       
        <!--==========Class dropdown============-->
        <div class = "col-md-2 green-text">
        <b>Current Rate: {{currentRate}}</b>
        </div>
        <div class="col-md-3">
            <b-form-group  label="From" label-for="datepicker-1" autocomplete="off">
              <b-form-datepicker id="datepicker-1" v-model= "FromDate" placeholder="Choose a date" local="en" @input="getUnitRates()" required></b-form-datepicker>
            </b-form-group> 
        </div>
        <div class="col-md-3">
            <b-form-group  label="To" label-for="datepicker-2" autocomplete="off">
              <b-form-datepicker id="datepicker-2" v-model= "ToDate" placeholder="Choose a date" local="en" @input="getUnitRates()" required></b-form-datepicker>
            </b-form-group> 
        </div>
        <!---SEARCH BOX-->
       
      
        <div class="col-md-1 Add-button" style="text-align:center">
          <a href="javascript:void(0)">
            <div class="AddButton">
              <div class="icon">
                <i class="fas fa-arrow-alt-circle-right fa-1x" style="color: rgb(255, 50, 55);">
                </i>
              </div>
              <div data-text="Add" class="name add-btn" v-b-modal.AddUnitRateModal>Add </div>
            </div>
          </a>
        </div> 

       </div>
       <div class="row">
         <div class="col">
          <hr color="#CACACA" style="border-top: 2px solid rgb(202, 202, 202); margin-top: 5px;">
         </div>
        </div>
      <div>
        <div class="row"><div class="col">
        <table class="table table-striped table-borderless cutom-table table-striped table-sm" 
          style="font-size: 85%;">
            <thead>
              <tr>
             
                <th role="columnheader">Effective From</th>
                <th role="columnheader">Rate</th>
              </tr>
            </thead>
            <tbody>
              <!--IF STUDENTS ARRAY HAS NO VALUE THEN SHOW WITHOUT SHOWING DATA-->
              <tr v-if= "unitRates==null" >
                <td class = "center-td" colspan="2">No Data</td>
              </tr>
              
            <tr v-else v-for="record in unitRates" :key=record.id>
              <td  role="cell">{{record.effectiveDate | moment("MMMM Do YYYY") }}</td>
              
              <td  role="cell">{{record.rate}} </td>
             
            </tr>
          </tbody>
        </table>
      </div></div>

      

    <!--PAGINATION START-->
    <div class="row justify-content-between align-items-center">
      <div class="col-md-2">
        <div class="showPages">
          <select class="form-control" id="selClass" v-model="perPage" 
          @change="getUnitRates()">
            <option v-for="option in options" :key="option.value" :value="option.value">
            {{option.text}}
            </option>
          </select>
        </div>
      </div>

      <div class="col-md-8 d-flex justify-content-center">
        <div class="overflow-auto">
            <b-pagination
              v-model= "page"
              :total-rows= rows
              :per-page="perPage"
              first-text="First"
              prev-text="Prev"
              next-text="Next"
              last-text="Last"
              @change="getPage"
            ></b-pagination>
          </div>
      </div>

       <div class="col-md-2">
        <input class="form-control search-box page-no-search" type="text" v-bind:placeholder="page" aria-label="search" v-model.number="pageNumOnSearch" style="height:38px">
      
        <button class="search-button btn btn-primary search page-no-search-btn" @click="search()">
              GO
        </button>

       </div>
    </div>
    <!--/PAGINATION END-->	
    <!--SPINNER-->	
    <Spinner v-if="isLoading" message="Loading..." size="medium" 
      line-fg-color="rgb(222 224 219" 
      line-bg-color="rgb(68 66 62)">
    </Spinner>
    <!--/SPINNER-->	
      </div>
    <AddUnitRateModal/>
    
     
  </div>
</template>

<script>
import axios from 'axios';
// import config from '../config.js';
import Spinner from 'vue-simple-spinner'
import AddUnitRateModal from './modals/AddUnitRateModal'


export default {
    name: 'UnitRate',
    data(){
        return{
          moduleName:'Unit Rate',
     
          FromDate:new Date(),
          ToDate:new Date(),
          isLoading:false,
         
          unitRates:null,
          currentRate:null,
          pageNumOnSearch:'',
          filteredText:'',
          rows:0,
           page: 1,
          options: [
            { text: 'Show 2',  value: 2 },
            { text: 'Show 10',  value: 10 },
            { text: 'Show 25',  value: 25 },
            { text: 'Show 50',  value: 50 },
            { text: 'Show 100', value: 100 }
          ],
          perPage:25     
		}
  },
 
methods:{


    getPage(page)
  {
    this.page = page;
    this.getUnitRates();
  },

   
    getUnitRates(){
       this.isLoading = true;
      axios.post('/unitrate/getall',{"CompanyId":this.$auth.user().companyId,
      "PageSize":this.perPage,"Page":this.page,"Text":this.filteredText,"FromDate":this.FromDate,"ToDate":this.ToDate})
    .then(res=>{
      this. isLoading = false;
      console.log(res)
      if(res.data.status == 1)
      {
       
        this.unitRates=res.data.data.records;
        this.currentRate = res.data.data.currentRate;
        this.rows = res.data.totalRecords;
      }
      else if(res.data.status== -1)
      {
          this.$bvModal.msgBoxOk(res.data.msg, {
          title: 'Error!',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          headerClass: 'p-10 border-bottom-0',
          footerClass: 'p-2 border-top-0',
          centered: true
          });
      }
      else {
        this.unitRates = null;
      
      }
    });
    },
		
   

  search(){
   
    this.page=this.pageNumOnSearch;
    this.getUnitRates();
  }
  },
	created(){
    this.FromDate = new Date(this.FromDate.getFullYear(), this.FromDate.getMonth(), 1,this.FromDate.getHours());
     this.ToDate = new Date(this.ToDate.getFullYear(), this.ToDate.getMonth()+1, 0,this.ToDate.getHours());
    this.getUnitRates();
    // this.getStudents();
    //localStorage.setItem("mytime", Date.now());
  },
  components:{
    Spinner,
    
    AddUnitRateModal
   
  },
  
}
</script>

<style scoped>
button.page-link {
	display: inline-block;
}
button.page-link {
    font-size: 20px;
    color: #29b3ed;
    font-weight: 500;
}
.offset{
  width: 500px !important;
  margin: 20px auto;  
}
select#class-dropdown{
    width: 80%;
    margin-left: 16%
}
.row{
  margin-left:0px;
  margin-right:0px;
}
.col{
  padding-left:0px;
  padding-right:0px;
}
</style>